// In its own file to avoid circular dependencies
export const NOTEBOOK_EDIT_TOOL_NAME = 'NotebookEdit'
